module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/most1-b2d2f49f88dfe64005cd43453617f39f.jpg";